export default "__VITE_ASSET__CWxoWH1V__"